import { Alert, Drawer, Space, Spin, Tabs, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FailedJobsPanel } from "../components/FailedJobsPanel";
import { QueueCard } from "../components/QueueCard";
import { ScheduledTasksPanel } from "../components/ScheduledTasksPanel";
import { SchedulersTable } from "../components/SchedulersTable";
import { useQueueCounts, useSchedulers } from "../hooks/useJobs";

const { Title } = Typography;

/**
 * Fon vazifalari — **faqat o'qish va RETRY** (kontrakt §6.3, spec §8.2).
 *
 * ⚠️⚠️ Job o'chirish, navbat tozalash yoki vazifani qo'lda `done` qilish
 * YO'Q va qo'shilmaydi: bu amallar domen invariantlarini jimgina buzadi
 * va qaytarib bo'lmaydi. Backendda ham bunday marshrut yo'q.
 */
export function JobsPage() {
	const { t } = useTranslation("jobs");
	const [failedQueue, setFailedQueue] = useState<string | null>(null);
	const queues = useQueueCounts();
	const schedulers = useSchedulers();

	return (
		<div>
			<Title level={3} className="mb-6">
				{t("page.title")}
			</Title>

			<Tabs
				defaultActiveKey="queues"
				items={[
					{
						key: "queues",
						label: t("page.tabs.queues"),
						children: (
							<>
								{queues.isError ? (
									<Alert type="error" message={t("page.queueLoadError")} showIcon />
								) : null}
								{queues.isLoading ? <Spin /> : null}
								<Space wrap size="middle" align="start">
									{(queues.data ?? []).map((status) => (
										<QueueCard key={status.name} status={status} onShowFailed={setFailedQueue} />
									))}
								</Space>
							</>
						),
					},
					{
						key: "scheduled-tasks",
						label: t("page.tabs.scheduledTasks"),
						children: <ScheduledTasksPanel />,
					},
					{
						key: "schedulers",
						label: t("page.tabs.schedulers"),
						children: (
							<SchedulersTable items={schedulers.data ?? []} isLoading={schedulers.isLoading} />
						),
					},
				]}
			/>

			{/* ⚠️ Panel faqat navbat tanlanganda mount qilinadi — aks holda
			    sahifa ochilishida har navbat uchun bitta ortiqcha so'rov
			    ketardi (`useFailedJobs` izohi). */}
			<Drawer
				title={
					failedQueue
						? t("page.drawerTitleWithQueue", { queue: failedQueue })
						: t("page.drawerTitle")
				}
				size={840}
				open={failedQueue !== null}
				onClose={() => setFailedQueue(null)}
			>
				{failedQueue ? <FailedJobsPanel queueName={failedQueue} /> : null}
			</Drawer>
		</div>
	);
}
